import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Context as StoreUserContext } from '../../../../providers/StoreUserContextProvider';
import { Context as HelperContext } from '../../../../providers/HelperContextProvider';
import ResponsiveWebstoreModal from './ResponsiveWebstoreModal';
import { config as defaultProductDisplayConfig } from './pages/wsDefaultProductDisplayConfig';
import { useWebstoreUserHelper } from '../../../../helpers/shop/webstoreHelper';
import WsProductInformationDisplay from './sections/productInformation/WsProductInformationDisplay';
import { useMediaQueries } from '../../../../helpers/hooks';

const CustomizeCartProductModal = ({
  baseStoreUrl,
  mediaQueries,
  editModeEnabled,
  onNavigate,
  colorSchemes,
  ecomStoreTheme,
  themeConfig,
  pathname
}) => {
  const { findOrFetchStoreProduct } = useWebstoreUserHelper();
  const {
    state: helperState,
    toggleWebstoreCheckoutSummaryDrawer
  } = useContext(HelperContext);
  const { state } = useContext(StoreUserContext);
  const { isTabletOrSmaller } = mediaQueries || useMediaQueries();

  const {
    ecomStoreCartProduct,
    ecomStoreCartPackage
  } = helperState.webstore.checkoutSummaryDrawer;
  const urlHandle =
    ecomStoreCartPackage?.urlHandle ||
    ecomStoreCartProduct?.ecomStoreProductVariant.ecomStoreProduct.urlHandle;
  const pkEcomStore =
    ecomStoreCartPackage?.ecomStoreProductPackage.fkEcomStore ||
    ecomStoreCartProduct?.ecomStoreProductVariant.ecomStoreProduct.pkEcomStore;

  const ecomStoreProduct = state.ecomStoreProductHistory.value.find(
    (c) => c.urlHandle === urlHandle
  );

  const productNotFound =
    ecomStoreCartPackage &&
    state.ecomStoreProductHistory.urlsNotFound.includes(
      ecomStoreCartPackage.urlHandle
    );

  useEffect(() => {
    if (
      helperState.webstore.checkoutSummaryDrawer.showProductCustomization &&
      urlHandle &&
      !ecomStoreProduct
    ) {
      findOrFetchStoreProduct(pkEcomStore, { urlHandle });
    }
  }, [helperState.webstore.checkoutSummaryDrawer.showProductCustomization]);

  const onClose = () => {
    toggleWebstoreCheckoutSummaryDrawer({
      ...helperState.webstore.checkoutSummaryDrawer,
      showProductCustomization: false
    });
  };

  return (
    <ResponsiveWebstoreModal
      alignModal={isTabletOrSmaller ? 'end' : 'center'}
      editModeEnabled={editModeEnabled}
      isOpen={
        helperState.webstore.checkoutSummaryDrawer.showProductCustomization
      }
      noHeader
      onClose={onClose}
      radius={0}
      size={1200}
      trapFocus={false}
      zIndex={201}
    >
      <WsProductInformationDisplay
        baseStoreUrl={baseStoreUrl}
        blocks={defaultProductDisplayConfig.blocks.filter(
          (b) => !b.isVisible || b.isVisible({ isCartEdit: true })
        )}
        colorSchemes={colorSchemes}
        config={defaultProductDisplayConfig}
        ecomStoreCartPackage={ecomStoreCartPackage}
        ecomStoreCartProduct={ecomStoreCartProduct}
        ecomStoreProduct={ecomStoreProduct}
        ecomStoreTheme={ecomStoreTheme}
        editModeEnabled={editModeEnabled}
        isCartEdit
        onAddOrUpdateCallback={onClose}
        onEditCancel={onClose}
        onNavigate={onNavigate}
        pathname={pathname}
        productNotFound={productNotFound}
        themeConfig={themeConfig}
      />
    </ResponsiveWebstoreModal>
  );
};

CustomizeCartProductModal.propTypes = {
  baseStoreUrl: PropTypes.string,
  colorSchemes: PropTypes.array,
  ecomStoreTheme: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pathname: PropTypes.string,
  themeConfig: PropTypes.object
};

export default CustomizeCartProductModal;
